export function round(amount: number, decimals: number): number {
  const multiplier = Math.pow(10, decimals)
  return Math.round(amount * multiplier) / multiplier
}

export const formatNumber = (number: number, options?: Intl.NumberFormatOptions): string => {
  const defaultOptions: Intl.NumberFormatOptions = {
    style: 'decimal',
    maximumFractionDigits: 0,
    ...options,
  }
  const formatter = new Intl.NumberFormat('en-US', defaultOptions)
  return formatter.format(number)
}

export const shortenNumber = (number: number): string => {
  const ranges = [
    { divider: 1e18, suffix: 'E' },
    { divider: 1e15, suffix: 'P' },
    { divider: 1e12, suffix: 'T' },
    { divider: 1e9, suffix: 'B' },
    { divider: 1e6, suffix: 'M' },
    { divider: 1e3, suffix: 'k' },
  ]

  const formatNumber = (n: number): string => {
    // fix number to 2 decimeal places
    const number = Number.parseFloat(n.toFixed(2))
    for (let i = 0; i < ranges.length; i++) {
      if (n >= ranges[i].divider) {
        return formatNumber(number / ranges[i].divider) + ranges[i].suffix
      }
    }
    return number.toString()
  }

  if (number < 0) {
    return '-' + formatNumber(-number)
  }
  return formatNumber(number)
}

const english_ordinal_rules = new Intl.PluralRules('en', { type: 'ordinal' })
const suffixes = {
  one: 'st',
  two: 'nd',
  few: 'rd',
  other: 'th',
}

export function ordinal(number: number): string {
  const suffix = suffixes[english_ordinal_rules.select(number) as keyof typeof suffixes]
  return number + suffix
}
